module.exports = __webpack_public_path__ + "toGroom-jp-r-b.1860c8c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toGroom-jp-r-b.jpg
// module id = ZMet
// module chunks = 0